module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("Second Reality")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "font-family": "Calisto Mt",
      "margin-left": "-10px",
      "margin-top": "20px",
      "font-weight": "normal !important"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_000#toc_id_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_001#toc_id_2"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_002#toc_id_3"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_003#toc_id_4"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_005#id_Toc146373207"
    }
  }, [_vm._v("Chapter One: Reality")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_006#id_Toc146373208"
    }
  }, [_vm._v("Chapter Two: Ocean Petals")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_007#id_Toc146373209"
    }
  }, [_vm._v("Chapter Three: Friends Rock")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_008#id_Toc146373210"
    }
  }, [_vm._v("Chapter Four: Crazy Truths")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_009#id_Toc146373211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Sudden Death")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_010#id_Toc146373212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Instant Travel")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_011#id_Toc146373213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Anxious Defeats")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_012#id_Toc146373214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Knowing Home")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_013#id_Toc146373215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Fingertips")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_014#id_Toc146373216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: The Tunnel")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_015#id_Toc146373217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: Breathe Slowly")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_016#id_Toc146373218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: I’ll Come")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_017#id_Toc146373219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: But It Does")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_018#id_Toc146373220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: Control")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_019#id_Toc146373221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: Like an Animal")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_020#id_Toc146373222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: My Awakening")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_021#id_Toc146373223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: My Turn")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_022#id_Toc146373224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen: Who I Am")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_023#id_Toc146373225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen: Yes")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_024#id_Toc146373226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0